<template>
  <div>
    <ciao-booking-sidebar/>

    <ciao-booking-settings
      :is-open="isOpenSettings"
      @close-settings="isOpenSettings = false"
    />

    <ciao-booking-navbar @open-settings="isOpenSettings = true" />

    <v-main>
      <ciao-booking-banner></ciao-booking-banner>
      <v-container fluid>
        <ciao-booking-alerts/>

        <ciao-booking-title :route="$route" />

        <router-view/>
      </v-container>
    </v-main>

    <ciao-booking-footer/>

    <ciao-booking-terms/>
  </div>
</template>

<script>
  import CiaoBookingFooter from "@/components/layouts/partials/Footer";
  import CiaoBookingNavbar from "@/components/layouts/partials/Navbar";
  import CiaoBookingSidebar from "@/components/layouts/partials/Sidebar";
  import CiaoBookingSettings from "@/components/layouts/partials/Settings";
  import CiaoBookingTitle from "@/components/layouts/partials/Title";
  const CiaoBookingAlerts = () => import("@/components/layouts/partials/Alerts");
  const CiaoBookingBanner = () => import("@/components/layouts/partials/Banner");
  const CiaoBookingTerms = () => import("@/components/layouts/partials/Terms");

  export default {
    name: "DefaultLayout",
    components: {
      CiaoBookingFooter,
      CiaoBookingNavbar,
      CiaoBookingSidebar,
      CiaoBookingSettings,
      CiaoBookingTitle,
      CiaoBookingAlerts,
      CiaoBookingBanner,
      CiaoBookingTerms,
    },
    data() {
      return {
        isOpenSettings: false,
      };
    },
  };
</script>
